<template>
  <div class="about">
    <md-tab-bar
      v-model="current"
      :items="items"
      :maxLength="3"
    />

    <md-field>
      <md-cell-item title="不错" addon="cds" arrow style="text-align:none;">
      </md-cell-item>
      <md-cell-item title="dddd" addon="吕进" arrow>
      </md-cell-item>
    </md-field>

    <md-field>
      <md-cell-item title="交通银行" brief="展示摘要描述" addon="附加文案">
        <span class="holder" slot="left">招</span>
        <p slot="children" style="font-size:0.24rem;color:#858B9C;">
          面向金融场景的Vue移动端UI组件库，丰富、灵活、实用，快速搭建优质的金融类产品，让复杂的金融场景变简单。基于「合理、好用」设计价值观，从交互操作、视觉抽象、图形可视等角度共同解决问题。
        </p>
      </md-cell-item>
      <md-cell-item title="交通银行" addon="附加文案" arrow></md-cell-item>
      <md-cell-item title="交通银行" addon="附加文案" arrow></md-cell-item>
      <md-cell-item title="交通银行" addon="附加文案" arrow></md-cell-item>
      <md-cell-item title="交通银行" addon="附加文案" arrow></md-cell-item>
    </md-field>

    <md-bill
      title="借款电子票据"
      no="12345689"
      water-mark="MAND-MOBILE"
    >
      <md-detail-item title="借款金额">
        &yen;30,000
      </md-detail-item>
      <md-detail-item title="收款账户">
        <md-icon name="bank-zs" svg style="margin-right:10px;"></md-icon>招商银行(尾号xxxx)
      </md-detail-item>
      <md-detail-item title="借款期数" content="12期" />
      <md-detail-item title="正常还款总息">
        &yen;140.50
      </md-detail-item>
      <md-detail-item title="还款">
        <md-tag
          size="small"
          shape="fillet"
          type="fill"
          fill-color="#858B9C"
          style="margin-right:4px;"
        >首次</md-tag>
        &yen;404.50&nbsp;(9月22日)
      </md-detail-item>
    </md-bill>

  </div>
</template>

<script>
import { departmentOfHospital } from '../api/daOrder'

import { Field, CellItem, Bill, DetailItem, Icon, Tag, TabBar } from 'mand-mobile'
export default {
  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Bill.name]: Bill,
    [DetailItem.name]: DetailItem,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [TabBar.name]: TabBar
  },
  data () {
    return {
      current: 'b',
      items: [
        { name: 'a', label: '精选' },
        { name: 'b', label: '全部' },
        { name: 'c', label: '满减券' },
        { name: 'd', label: '立减券' },
        { name: 'e', label: '免息券' },
        { name: 'f', label: '校园专享' },
        { name: 'g', label: '夜间优惠' },
        { name: 'h', label: '红包' }
      ]
    }
  },
  created () {
    departmentOfHospital(1240828687071309 /* this.$route.query.h */).then(res => {
      console.info('departmentOfHospital.res', res)
      this.departmentItems = res.data
    }).catch(err => {
      console.log('departmentOfHospital.err', err)
    })
  }
}
</script>
